import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IllustrationQuotationMark(props: Props) {
    return (
        <svg
            width="15"
            height="11"
            viewBox="0 0 15 11"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="IllustrationQuotationMark"
            {...props}
        >
            <path
                d="M11.5596 0C9.78646 0 8.32745 1.34063 8.13867 3.06348C8.13148 3.06344 8.12432 3.06348 8.11719 3.06348C7.9898 5.74112 9.1881 11.0189 15.002 10.7129C13.9746 10.2563 12.091 8.90062 11.9268 6.86523C13.6553 6.68185 15.002 5.21954 15.002 3.44238C15.0019 1.54125 13.4607 9.40549e-05 11.5596 0Z"
                fillOpacity={props.opacity}
            />
            <path
                d="M3.60449 0C1.83147 0.000119081 0.372341 1.34069 0.183594 3.06348C0.176419 3.06344 0.169217 3.06348 0.162109 3.06348C0.0347319 5.74107 1.23337 11.0186 7.04688 10.7129C6.01947 10.2561 4.13593 8.90042 3.97168 6.86523C5.70039 6.68203 7.04688 5.21968 7.04688 3.44238C7.04678 1.54119 5.50571 0 3.60449 0Z"
                fillOpacity={props.opacity}
            />
        </svg>
    );
}
